<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12NHQot/tc-custom/9781466800823.jpg?1728851752473" alt="This image is the cover for the book Just City, Thessaly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Just City, Thessaly
      </h1>
      <p class="bookDescription body article font2">
        <b>The goddess Athene attempts to create a utopia with robots and time travelers in this science fiction fantasy by a Hugo and Nebula Award–winning author.</b><br/><br/><b>“Walton’s no-nonsense prose and dialogue are the kind of thing I can read anywhere, in any situation, and fall into a world of intelligent people speaking to each other intelligently in interesting ways. . . . Brilliant, compelling, and frankly unputdownable.” —NPR</b><br/><br/>Created as an experiment by the time-traveling goddess Pallas Athene, the Just City is a planned community, populated by over ten thousand children and a few hundred adult teachers from all eras of history, along with some handy robots from the far human future—all set down together on a Mediterranean island in the distant past.<br/><br/>The student Simmea, born an Egyptian farmer’s daughter sometime between 500 and 1000 A.D., is a brilliant child, eager for knowledge, ready to strive to be her best self. The teacher Maia was once Ethel, a young Victorian lady of much learning and few prospects, who prayed to Pallas Athene in an unguarded moment during a trip to Rome—and, in an instant, found herself in the Just City with grey-eyed Athene standing unmistakably before her.<br/><br/>Meanwhile, Apollo—stunned by the realization that there are things mortals understand better than he does—has arranged to live a human life, and has come to the City as one of the children. He knows his true identity, and conceals it from his peers. For this lifetime, he is prone to all the troubles of being human.<br/><br/>Then, a few years in, Sokrates arrives—the same Sokrates recorded by Plato himself—to ask all the troublesome questions you would expect. What happens next is a tale only the brilliant Jo Walton could tell . . .<br/><br/><b>“A remarkable novel of ideas. . . . Superb.” —<i>Booklist</i> (Starred Review)</b><br/><br/><b>“A brilliant and haunting meditation on utopia, power, and consent—with deeply engaging characters and consummately clever world-building. Jo Walton has given us another winner.” —Susan Palwick</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jo Walton
      </h2>
      
      <p class="authorDescription body article"><P>JO WALTON won the Hugo and Nebula Awards in 2012 for her novel <I>Among Others</I>. Before that, she won the John W. Campbell Award for Best New Writer, and her novel <I>Tooth and Claw</I> won the World Fantasy Award in 2004. The novels of her Small Change sequence—<I>Farthing, Ha'penny</I>, and <I>Half a Crown</I>—have won acclaim ranging from national newspapers to the <I>Romantic Times</I> Critics' Choice Award. A native of Wales, she lives in Montreal.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?81a37b8a